import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from './../../../shared/confirm-dialog/confirm-dialog.component';
import { FlatNode } from './../../../sidebar-station/model/node.interface';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';
import { StationSource } from './../../../core/models/station-source';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { IhmLoadingIndicatorService, ToastService } from '@ihm-software/ihm-ui-common-angular-10';
import { SidebarStationService } from 'src/app/sidebar-station/sidebar-station.service';

import { StationManagementService } from './../../station-management.service';

@Component({
  selector: 'app-custom-source',
  templateUrl: './custom-source.component.html',
  styleUrls: ['./custom-source.component.scss']
})
export class CustomSourceComponent implements OnInit, OnDestroy {

  nameMenu = 'Sources';
  sourceForm: FormGroup;

  // Source fileds
  private idControl: FormControl = new FormControl({ value: null, disabled: true }, []);

  private nameControl: FormControl = new FormControl('', [
    Validators.required,
    Validators.minLength(3)
  ]);

  private shortNameControl: FormControl = new FormControl('', [Validators.required]);

  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();


  constructor(
    private readonly stationManagementService: StationManagementService,
    private readonly sidebarStationService: SidebarStationService,
    private readonly loaderService: IhmLoadingIndicatorService,
    private readonly toastServiceToast: ToastService,
    private formBuilder: FormBuilder,
    public readonly dialog: MatDialog
  ) { }

  ngOnInit() {
    this.sourceForm = this.initializeFormWithDefaultValues();
    this.loadSources();

    this.sidebarStationService.selectionItem.pipe(takeUntil(this.ngUnsubscribe)).subscribe((item: FlatNode) => {
      if (item?.value) {
        this.updateSource(item.value);
      }
    });

    this.stationManagementService.createEvent.pipe(takeUntil(this.ngUnsubscribe)).subscribe((isCreating: boolean) => {
      if (isCreating) {
        this.sourceForm.reset();
      }
    });

  }

  ngOnDestroy(): void {
    this.sidebarStationService.setSidebarListInMemory([]);
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.unsubscribe();
  }

  formIsEditable() {
    return true;
  }

  updateSource(item: StationSource) {
    this.setValueOnForm(item);
  }

  onFormSubmit() {
    if (!this.sourceForm.valid) {
      return;
    }
    this.loaderService.toggle(true);

    this.stationManagementService.createOrUpdateSource(this.sourceForm.getRawValue()).subscribe((response) => {
      if (response == null) {
        this.toastServiceToast.openSnackBar('Error on creating the station source.', 'Ok');
        return;

      }
      this.loadSources();
      this.toastServiceToast.openSnackBar(`Source
      ${this.sourceForm.getRawValue().id != null ? 'updated' : 'created'}.`, 'Ok');
      this.sourceForm.reset();

    },
      (error) => {
        console.error('Error on createStationSource ', error);
        this.toastServiceToast.openSnackBar('Error on creating the station source.', 'Ok');
      },
      () => {
        this.loaderService.toggle(false);

      });

  }

  deleteSource() {

    let text = 'Are you sure you want to remove this Custom Source? This action is <b>IRREVERSIBLE</b><br/>';
    text += `<br/>Source Id: <b>${this.sourceForm.getRawValue().id}</b>`;
    text += `<br/>Source Name: <b>${this.sourceForm.getRawValue().name}</b>`;
    text += `<br/>Short Name: <b>${this.sourceForm.getRawValue().shortname}</b>`;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: 'auto',
      height: 'auto',
      data: { text }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.loaderService.toggle(true);
        this.stationManagementService.deleteStationSource(this.sourceForm.getRawValue().id)
          .pipe(takeUntil(this.ngUnsubscribe)).subscribe(list => {
            this.loadSources();
            this.sourceForm.reset();
            this.loaderService.toggle(false);
            this.toastServiceToast.openSnackBar('Custom Source deleted.', 'Ok');
          },
            (error) => {
              console.error('Error on deleteSource ', error);
              this.toastServiceToast
                .openSnackBar('This Custom Source can\'t be removed because it is used in at least one station.', 'Ok');
              this.loaderService.toggle(false);
            });
      }
    });

  }

  // Private Methods

  private initializeFormWithDefaultValues(): FormGroup {
    return this.formBuilder.group({
      id: this.idControl,
      name: this.nameControl,
      shortname: this.shortNameControl
    });
  }

  private setValueOnForm(source: StationSource) {
    this.sourceForm.get('id').setValue(source?.id);
    this.sourceForm.get('name').setValue(source?.name);
    this.sourceForm.get('shortname').setValue(source?.shortname);
  }

  private loadSources() {
    this.stationManagementService.stationSourceList().pipe(takeUntil(this.ngUnsubscribe)).subscribe(list => {
      this.sidebarStationService.setSidebarListInMemory(
        [{
          name: this.nameMenu,
          children: list,
          expand: true
        }]
      );
    });
  }

}
